module.exports = __webpack_public_path__ + "img/chrome-icon.61299b79.png";